export const OFFLINE_ET_CONTEST = 'OFFLINE_ET_CONTEST';
